import {
  Backdrop,
  Box,
  CircularProgress,
  Container,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Snackbar,
  Typography,
} from "@mui/material";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import MuiAlert from "@mui/material/Alert";
import { useAddCart } from "../../Components/Context/CartContext";
import NewCustomerComponent from "../../Components/NewCustomerComponent";
import OptionDialog from "../../Components/OptionDialog";
import ProductPage from "../../Components/ProductPage";
import SelectGender from "../../Components/SelectGender";
import SelectGrade from "../../Components/SelectGrade";
import SelectSchool from "../../Components/SelectSchool";
import FirstPage from "../../Components/FirstPage";
import ResumeCustomer from "../../Components/ResumeCustomer";
import BreadCrumb from "../../Components/BreadCrumb";
import ExistingCustomer from "../../Components/ExistingCustomer";
import httpclient from "../../utils";
import { useParams } from 'react-router-dom';
import { useLocation } from 'react-router';

import PrintDialog from "../../Components/PrintDialog";
import { PaymentTwoTone } from "@mui/icons-material";


const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const ResetConfirmationDialog = ({ open, onCancel, onConfirm }) => {
  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle
        sx={{ paddingLeft: "30%", borderBottom: "1px solid #cf97d8" }}
      >
        Reset Confirmation
      </DialogTitle>
      <DialogContent>
        <p>
          Are you sure? This will clear the order and you need to start from
          beginning.
        </p>
      </DialogContent>
      <DialogActions
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Button
          size="large"
          variant="outlined"
          color="secondary"
          sx={{ margin: "10px" }}
          onClick={onCancel}
        >
          Cancel
        </Button>
        <Button
          size="large"
          variant="outlined"
          sx={{ margin: "10px" }}
          onClick={onConfirm}
          color="primary"
        >
          Reset
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const CustomerConfirmationDialog = ({ open, onCancel, onConfirm, customerDetails }) => {
  //console.log("cccccc", customerDetails);
  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle
        sx={{ paddingLeft: "20%", borderBottom: "1px solid #cf97d8" }}
      >
        <b>Existing Customer Confirmation</b>
      </DialogTitle>
      <DialogContent>
        <p>
          This user already exists with following credentials:
          <br />
          First Name:  <u>{customerDetails.firstName}</u>
          <br />
          Last Name:  <u>{customerDetails.lastName}</u>
          <br />
          Email:  <u>{customerDetails.email}</u>
          <br />
          Mobile: <u>{customerDetails.mobile}</u>
        </p>
        <p>
          Do you wish to proceed with the existing user?
        </p>
      </DialogContent>
      <DialogActions
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Button
          size="small"
          variant="outlined"
          color="secondary"
          sx={{ margin: "10px" }}
          onClick={onCancel}
        >
          No
        </Button>
        <Button
          size="small"
          variant="outlined"
          sx={{ margin: "10px" }}
          onClick={onConfirm}
          color="primary"
        >
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const AddPaymentType = ({ openDialog, closePaymentTypeDialog, handleSaveSalesOrder, paymentType, handlePaymentTypeChange }) => {

  return (
    <Dialog open={openDialog} onClose={closePaymentTypeDialog}>
      <DialogTitle>How would you like to pay?</DialogTitle>
      <DialogContent>
        <Box pt={2} sx={{ minWidth: 240 }}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Payment</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={paymentType}
              label="Payment"
              onChange={handlePaymentTypeChange}
            >
              <MenuItem value="">
                <em>Select Payment Type</em>
              </MenuItem>
              <MenuItem value="CASH">Cash</MenuItem>
              <MenuItem value="CARD">Card</MenuItem>
              <MenuItem value="TRANSFER">Transfer</MenuItem>
              <MenuItem value="CHECK">Check</MenuItem>
              <MenuItem value="GIFTCARD">Giftcard</MenuItem>
              {/* Add more payment types as needed */}
            </Select>
          </FormControl>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={closePaymentTypeDialog}>Cancel</Button>
        <Button onClick={handleSaveSalesOrder}>Save</Button>
      </DialogActions>
    </Dialog>
  );
};

const columns = [
  { id: "SchoolName", name: "School Name" },
  { id: "SchoolID", name: "School ID" },
];

// const columns1 = [
//   { id: "id", name: "ID" },
//   { id: "customerID", name: "Customer ID" },
//   { id: "firstName", name: "First Name" },
//   { id: "lastName", name: "Last Name" },
//   { id: "cart", name: "# of Items" },
//   { id: "email", name: "Email" },
//   { id: "mobile", name: "Mobile" },
//   { id: "actions", name: "Actions" },
// ];

const columns2 = [
  { id: "id", name: "ID" },
  { id: "number", name: "Order Number" },
  { id: "clientName", name: "Client Name" },
  { id: "sales_details", name: "Items" },
  { id: "type", name: "Type" },
  { id: "paymentStatus", name: "Payment Status" },
  { id: "paymentType", name: "Payment Type" },
  { id: "total", name: "Total" },
  { id: "created_at", name: "Purchase Date" },
  { id: "lastModifierUsername", name: "Last Modified By" },
  { id: "actions", name: "Actions" },
];

const Home = () => {

  if (sessionStorage.getItem("erplyLogin") === "1") {
    var erplyLogin = sessionStorage.getItem('erplyLogin');
  } else {
    var erplyLogin = localStorage.getItem('erplyLogin');
  }

  const addCart = useAddCart();
  const location = useLocation();
  const [customerDetails, setCustomerDetails] = useState({
    type: "",
    firstName: "",
    lastName: "",
    mobile: "",
    email: "",
    customerType: "",
    customerID: "",
    notify: false,

    school: "",
    schoolID: "",
    grade: "",
    gender: "",

    quantity: [],
    cart: 0,
    cartTotal: "",
    cartItems: [],
  });

  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [snackStatus, setSnackStatus] = useState("");
  const [snackMessage, setSnackMessage] = useState("");
  const [resetConfirmationOpen, setResetConfirmationOpen] = useState(false);
  const [customerConfirmationOpen, setCustomerConfirmationOpen] = useState(false);
  const [isLoadingPrintPreview, setIsLoadingPrintPreview] = useState(false);
  const [step, setStep] = useState(0);
  const [openViewOptions, setOpenViewOptions] = useState(false);
  const [viewOptionDetails, setViewOptionDetails] = useState([]);
  const [schoolList, setSchoolList] = useState([]);

  const [cartItems, setCartItems] = useState([]);
  const [keyLoading, setKeyLoading] = useState(false);
  const [keyLoading1, setKeyLoading1] = useState(false);
  const [deletingRow, setDeletingRow] = useState(null);
  const [rows, setRows] = useState([]);
  const [rows1, setRows1] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [paymentType, setPaymentType] = useState("");
  const [state, setState] = useState("");
  const [express, setExpress] = useState(false);
  const [payNow, setPayNow] = useState(true);
  const [trigger, setTrigger] = useState(false);
  const [showPrintDialog, setShowPrintDialog] = useState(false);
  const [printDetails, setPrintDetails] = useState("");

  const handleStep1 = () => {
    if (customerDetails.type === "resume" || customerDetails.type === "existing") {
      setStep(0);
    } else {
      setStep(1);
    }
  }

  const { id } = useParams();
  let pos = id;

  console.log("pos!", pos);

  useEffect(() => {
    const getOrders = setInterval(getCartOrders, 200000);
    return () => {
      clearInterval(getOrders);
    };
  }, []);

  useEffect(() => {
    getSchools();
    getAllCustomers();
    getCartOrders();
  }, []);

  const getSchools = () => {
    httpclient.get(`getSchool?posID=${pos}`).then(({ data }) => {
      if (data.status === 200) {
        const records = data.records;

        const schoolList = records.map((record) => {
          const school1 = {};

          columns.forEach((column) => {
            school1[column.id] = record[column.id];
          });

          return school1;
        });
        setSchoolList(records);
        localStorage.setItem("school-list", JSON.stringify(schoolList));
      } else {
        console.log("Error!");
      }
    });
  };


  const getAllCustomers = () => {
    httpclient
      .get(
        `getAllCustomers?warehouseID=${pos}&env=TEST&select=id,customerID,firstName,lastName,fullName,customerType,mobile,email`
      )
      .then(({ data }) => {
        if (data.status === 200) {
          const rows = data.records;

          setRows(rows);
          //console.log("list!", rows);
          localStorage.setItem("costumer-list", JSON.stringify(rows));

        } else {
          console.log("Error!");
        }
      });
  };

  const getCartOrders = () => {
    httpclient
      .get(`getCartOrders?env=TEST&warehouseID=${pos}`)
      .then(({ data }) => {
        if (data.status === 200) {
          const rows1 = data.records;

          setRows1(rows1);
          localStorage.setItem("order-list", JSON.stringify(rows1));
        } else {
          console.log("Error!");
        }
      });
  };


  function handleRefetch() {
    setTimeout(() => {
      window.location.reload();
    }, 4000);
  }


  const handleResume = (row) => {
    //console.log("row", row);
    setStep(2);

    const attributes = JSON.parse(row.attributes);
    //console.log("Parsed attributes:", attributes);
    setExpress(row.isExpress === 1 ? true : false);
    setPayNow(row.payNow === 1 ? true : true);
    var customer = {
      //express:row.isExpress === 1 ? true : false,
      quantity: {},
      cartItems: [],
      cart: row.sales_details.length,
      salesDocumentID: row.salesDocumentID,
      customerID: row.clientID,
      clientName: row.clientName,
      schoolID1: attributes[0].attributeValue,
      type: "resume",
      cartTotal: 0,
    };

    row.sales_details.forEach((sale) => {
      var cartItem = {
        //id: sale.id,
        id: sale.productID,
        RetailSalesPrice: sale.ax_relation.RetailSalesPrice,
        ItemName: sale.ax_relation.ItemName,
        ColourName: sale.ax_relation.ColourName,
        imageUrl: sale.ax_relation.imageUrl,
        schoolID: sale.ax_relation.SchoolID,
        SizeID: sale.ax_relation.SizeID,
        ColourID: sale.ax_relation.ColourID,
        WEBSKU:sale.ax_relation.WEBSKU,
      };

      customer.cartItems.push(cartItem);
      //customer.cartItems[sale.id] = cartItem;
      customer.quantity[sale.productID] = parseInt(sale.amount);
      customer.cartTotal += parseInt(sale.amount);
    });

    setCustomerDetails(customer);


    //console.log("customer", customer);
  };



  const handleDelete = (row) => {
    const confirmed = window.confirm(
      "Are you sure you want to delete this order?"
    );

    if (confirmed) {
      setKeyLoading(true);
      setDeletingRow(row.id);

      httpclient
        .post(
          `deleteOrder?env=TEST&warehouseID=${pos}&salesDocumentID=${row.salesDocumentID}`
        )
        .then(({ data }) => {
          if (data.status === 200) {
            setKeyLoading(false);
            setOpen(true);
            setSnackStatus("success");
            setSnackMessage(data.message);
            //localStorage.setItem('orderDeleted', 'true');
            // setTimeout(() => {
            //   setStep(1);
            // }, 1000);
            setTimeout(() => {
              window.location.reload();
            }, 2000);
          } else {
            setKeyLoading(false);
            setOpen(true);
            setSnackStatus("error");
            setSnackMessage(data.message);
          }
        })
        .catch((error) => {
          setOpen(true);
          setKeyLoading(false);
          setSnackStatus("error");
          setSnackMessage("Failed to delete order!");
        });
    }
  };


  // if (localStorage.getItem('orderDeleted') === 'true') {
  //   // Clear the flag to avoid unwanted behavior on subsequent reloads
  //   localStorage.removeItem('orderDeleted');

  //   // Call the handleStep1 function
  //   handleStep1();
  // }

  // const [openConfirmation, setOpenConfirmation] = useState(false);

  // const handleConfirmation = () => {
  //   setOpenConfirmation(true);
  // };

  // const handleConfirmationClose = () => {
  //   setOpenConfirmation(false);
  // };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
    setOpen2(false);
    setTrigger(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCustomerDetails({
      ...customerDetails,
      [name]: value,
    });

  };

  const handleCheck = (e) => {
    const { name, checked } = e.target;

    setCustomerDetails({
      ...customerDetails,
      [name]: checked,
    });
  };

  const handleClickSchool = (SchoolName, SchoolID) => {
    // console.log("schoolName", SchoolName);
    // console.log("schoolID", SchoolID);

    setCustomerDetails({
      ...customerDetails,
      school: SchoolName,
      schoolID: SchoolID,
    });

    setTimeout(() => {
      setStep(step + 1);
    }, 500);
  };

  const handleClickSchool1 = () => {
    setState("cart");
    setTimeout(() => {
      setStep(step + 1)
    }, 500);
  };


  const handleChangeSchool = (value) => {
    // console.log("value11111111", value);
    setCustomerDetails({
      ...customerDetails,
      school: value !== null ? value.SchoolName : "",
      schoolID: value !== null ? value.SchoolID : "",
    });
  };


  const handleChangeGrade = (value) => {
    setCustomerDetails({
      ...customerDetails,
      grade: value !== null ? value : "",
    });

    setTimeout(() => {
      setStep(step + 1);
    }, [500]);
  };

  const handleChooseGender = (value) => {
    setCustomerDetails({
      ...customerDetails,
      gender: value,
    });

    setTimeout(() => {
      setStep(step + 1);
    }, [500]);
  };



  const handleQuantity = (e, productID, soh) => {
    const { name, value } = e.target;
    console.log("handle quantity called", soh);
    let newQuantity = parseInt(value);

    if (newQuantity < 1) {
      newQuantity = 1;
    }
    if (soh === "1") {
      setOpen(true);
      setSnackStatus("warning");
      setSnackMessage("You are exceeding the total stock available");

    }

    if (soh !== undefined && newQuantity > soh) {
      newQuantity = soh;
      setOpen(true);
      setSnackStatus("warning");
      setSnackMessage("You are exceeding the total stock available");
    }
    customerDetails.quantity[productID] = newQuantity;
    setCustomerDetails({
      ...customerDetails,
      quantity: customerDetails.quantity,
    });
  };

  const handleSubstract = (val) => {
    if (
      customerDetails.quantity[val] === undefined ||
      customerDetails.quantity[val] === 0
    ) {
      customerDetails.quantity[val] = 0;
    } else if (customerDetails.quantity[val] > 1) {
      customerDetails.quantity[val] = customerDetails.quantity[val] - 1;
    }

    if (customerDetails.quantity[val] < 1) {
      customerDetails.quantity[val] = 1;
    }
    const cartTotal = calculateCartTotal(cartItems, customerDetails.quantity);
    setCustomerDetails({
      ...customerDetails,
      quantity: customerDetails.quantity,
      cartTotal: cartTotal,
    });
  };

  const handleAdd = (val, soh) => {
    if (soh === "1") {
      setOpen(true);
      setSnackStatus("warning");
      setSnackMessage("You are exceeding the total stock available");
    }
    else if (customerDetails.quantity[val] === undefined) {
      customerDetails.quantity[val] = 2;
    } else {
      //customerDetails.quantity[val] = customerDetails.quantity[val] + 1;
      if (soh !== undefined) {
        if (customerDetails.quantity[val] + 1 <= soh) {
          customerDetails.quantity[val] = customerDetails.quantity[val] + 1;
        } else {
          setOpen(true);
          setSnackStatus("warning");
          setSnackMessage("You are exceeding the total stock available");
        }
      } else {
        customerDetails.quantity[val] = customerDetails.quantity[val] + 1;
      }
    }
    const cartTotal = calculateCartTotal(cartItems, customerDetails.quantity);
    setCustomerDetails({
      ...customerDetails,
      quantity: customerDetails.quantity,
      cartTotal: cartTotal,
    });
  };

  // const handleQuantity = (e, id) => {
  //   const { name, value } = e.target;
  //   const updatedQuantity = {
  //     ...customerDetails.quantity,
  //     [id]: parseInt(value),
  //   };
  //   setCustomerDetails({
  //     ...customerDetails,
  //     quantity: updatedQuantity,
  //   });
  // };

  // const handleAdd = (val) => {
  //   const updatedQuantity = {
  //     ...customerDetails.quantity,
  //     [val]: (customerDetails.quantity[val] || 0) + 1,
  //   };
  //   setCustomerDetails({
  //     ...customerDetails,
  //     quantity: updatedQuantity,
  //   });
  // };

  // const handleSubstract = (val) => {
  //   const updatedQuantity = {
  //     ...customerDetails.quantity,
  //     [val]: Math.max((customerDetails.quantity[val] || 0) - 1, 0),
  //   };
  //   setCustomerDetails({
  //     ...customerDetails,
  //     quantity: updatedQuantity,
  //   });
  // };

  // const handleOpenOptions = (product) => {
  //   setOpenViewOptions(true);
  //   setViewOptionDetails(product);
  // };

  // const sendOption = (callback) => {
  //   if (callback.open === false) {
  //     setOpenViewOptions(false);
  //     setViewOptionDetails([]);
  //   }
  //   if(callback.refetch === true){
  //     console.log("trueeeeeeeeee");
  //   }
  // };

  // const handleAddToCart = (id) => {
  //   addCart();
  //   setOpen(true);
  //   setSnackStatus("success");
  //   setSnackMessage("Item added to cart");

  //   setCustomerDetails({
  //     ...customerDetails,
  //     cart: customerDetails.cart + 1,
  //   });
  // };

  const calculateCartTotal = (cartItems, quantity) => {
    let total = 0;
    //console.log('cart items calculation', cartItems);
    for (const item of cartItems) {
      const itemId = item.id;
      const itemQuantity = quantity[itemId] || 0;
      total += itemQuantity;
    }
    // console.log("total", total);
    return total;
  };

  const handleRemoveFromCart = (id) => {
    const confirmed = window.confirm(
      "Are you sure you want to delete this item from cart?"
    );

    if (confirmed) {
      const index = customerDetails.cartItems.findIndex(
        (item) => item.id === id
      );
      //console.log('handle quantity called1111111', index)

      if (index === -1) {
        return;
      }
      const newCartItems = [...customerDetails.cartItems];
      newCartItems.splice(index, 1);

      const updatedQuantity = { ...customerDetails.quantity };
      delete updatedQuantity[id];

      const cartTotal = calculateCartTotal(newCartItems, updatedQuantity);
      setCartItems(newCartItems);
      // setCustomerDetails((prevDetails) => (
      //   {
      //   ...prevDetails,
      //   cart: prevDetails.cart - 1,
      //   cartItems: newCartItems,
      // }));
      setCustomerDetails((prevDetails) => {
        const updatedQuantity = { ...prevDetails.quantity };
        delete updatedQuantity[id];

        return {
          ...prevDetails,
          cart: prevDetails.cart - 1,
          cartTotal: cartTotal,
          cartItems: newCartItems,
          quantity: updatedQuantity,
        };
      });
      setOpen(true);
      setSnackStatus("error");
      setSnackMessage("Item deleted from cart");
    }
  };

  // const handleAddToCart = (id, productID, SchoolID, ItemName, DefaultStore, RetailSalesPrice) => {

  //   // Create a new item with the product details and add it to the cart items
  //   const newItem = {
  //     id: id,
  //     productID: productID,
  //     schoolID: SchoolID,
  //     ItemName: ItemName,
  //     DefaultStore: DefaultStore,
  //     RetailSalesPrice: RetailSalesPrice,
  //   };
  //   // const updatedQuantity = {
  //   //   ...customerDetails.quantity,
  //   //   [id]: 1,
  //   // };

  //   var currCartItems = customerDetails.cartItems;
  //   currCartItems.push(newItem);

  //   // console.log('curr cart ', currCartItems);

  //   var newCartItems = currCartItems.filter((cart,index) => currCartItems.findIndex((item) => cart.id === item.id) === index)
  //   // console.log('new cart  >>>>>>>>>>>>>>>>>>>', newCartItems)

  //   var cartTotal = calculateCartTotal(newCartItems, customerDetails.quantity);

  //   setCartItems(newCartItems);
  //   // Update the customer details
  //   setCustomerDetails((prevDetails) => ({
  //     ...prevDetails,
  //     cart: newCartItems.length,
  //     cartTotal: cartTotal,
  //     cartItems: newCartItems,
  //     // quantity: updatedQuantity,

  //   }));

  //   // Show the success message
  //   setOpen(true);
  //   setSnackStatus("success");
  //   setSnackMessage("Item added to cart");
  // };

  const handleAddToCart = (
    productID,
    SchoolID,
    ItemName,
    ColourName,
    SizeID,
    ColourID,
    RetailSalesPrice,
    imageUrl,
    WEBSKU
  ) => {
    const newItem = {
      //id: id,
      id: productID,
      schoolID: SchoolID,
      ItemName: ItemName,
      ColourName: ColourName,
      SizeID: SizeID,
      ColourID: ColourID,
      RetailSalesPrice: RetailSalesPrice,
      imageUrl: imageUrl,
      WEBSKU: WEBSKU,
    };

    var currCartItems = customerDetails.cartItems;
    currCartItems.push(newItem);

    var newCartItems = currCartItems.filter(
      (cart, index) =>
        currCartItems.findIndex((item) => cart.id === item.id) === index
    );

    var cartTotal = calculateCartTotal(newCartItems, customerDetails.quantity);

    setCartItems(newCartItems);
    setCustomerDetails((prevDetails) => ({
      ...prevDetails,
      cart: newCartItems.length,
      cartTotal: cartTotal,
      cartItems: newCartItems,
      //quantity: updatedQuantity,
    }));
    
    setOpen(true);
    setSnackStatus("success");
    setSnackMessage("Item added to cart");
    setTrigger(true);
  };

  // const handleSaveCustomerDetails = () => {
  //   // console.log("save >>", customerDetails);
  //   setCustomerDetails({
  //     firstName: "",
  //     lastName: "",
  //     mobile: "",
  //     email: "",
  //     notify: false,

  //     school: "",
  //     grade: "",
  //     gender: "",

  //     quantity: [],
  //     cart: 0,
  //     cartItems: [],
  //     type: "",
  //   });
  //   setOpen(true);
  //   setSnackStatus("success");
  //   setSnackMessage("Customer Details has been saved successfully!");
  //   setTimeout(() => {
  //     setStep(0);
  //   }, 1000);

  // };
  // console.log("Customer Details has been saved successfully! >>", customerDetails);

  const handleSaveCustomerDetails = () => {
    setKeyLoading(true);
    httpclient
      .post(`saveCustomer?env=TEST&erplyLogin=${erplyLogin}`, {
        homeStoreID: pos,
        firstName: customerDetails.firstName,
        lastName: customerDetails.lastName,
        mobile: customerDetails.mobile,
        notify: customerDetails.notify,
        email: customerDetails.email,
        customerType: "PERSON",
      })
      .then(({ data }) => {
        if (data.status === 200) {
          setKeyLoading(false);
          setOpen2(true);
          // setKeyLoading(false);
          setSnackStatus("success");
          setSnackMessage(data.message);
          setCustomerDetails({
            ...customerDetails,
            clientID: data.records.clientID,
            customerID: data.records.customerID,
            alreadyExists: data.records.alreadyExists,
          });
          // setTimeout(() => {
          //   setStep(step);
          // }, 500);
          setTimeout(() => {
            getAllCustomers();
            setStep(step + 1);
          }, 500);
          // setTimeout(() => {
          //   window.location.reload();
          // }, 2000);

        } else if (data.status === 400) {
          setKeyLoading(false);
          setOpen2(true);
          setSnackStatus("warning");
          setSnackMessage(data.message);
          setCustomerDetails({
            ...customerDetails,
            type: "existing",
            customerID: data.records.customerID,
            fullName: data.records.fullName,
            firstName: data.records.firstName,
            lastName: data.records.lastName,
            email: data.records.email,
            mobile: data.records.mobile,

          });

          setTimeout(() => {
            // customerDetails.type = "existing"
            // handleStep1()
            setCustomerConfirmationOpen(true);
            setOpen2(false);
          }, 500);
        }
        else {
          setKeyLoading(false);
          setOpen2(true);
          setSnackStatus("error");
          setSnackMessage(data.message);
          setKeyLoading(false);
        }
      });
  };
  //console.log("Customer Details",customerDetails.cartItems[0].productID );
  //const schoolIDs = customerDetails.cartItems.map((item) => item.schoolID); // Extract all schoolIDs from cartItems

  // Filter unique schoolIDs and join them as comma-separated values
  //requestData.attributeValue1 = [...new Set(schoolIDs)].join(",");
  //console.log("schoolIDs", schoolIDs)


  const handleSaveSalesOrder = () => {
    setKeyLoading(true);
    var requestData = {
      type: "OFFER",
      warehouseID: pos,
      customerID: customerDetails.customerID,
      paymentType: paymentType,
      express: express,
      cartTotal: 0,
      attributeName1: "SchoolName",
      attributeType1: "text",
      attributeValue1: "",
    };

    const schoolIDs = customerDetails.cartItems.map((item) => item.schoolID); // Extract all schoolIDs from cartItems

    // Filter unique schoolIDs and join them as comma-separated values
    requestData.attributeValue1 = [...new Set(schoolIDs)].join(",");
    //console.log("schoolIDs", schoolIDs)

    let cartTotal = 0;

    customerDetails.cartItems.forEach((item, index) => {
      requestData[`productID${index + 1}`] = item.id;
      requestData[`price${index + 1}`] = item.RetailSalesPrice;
      requestData[`discount${index + 1}`] = "0";

      const quantity = customerDetails.quantity[item.id] || 1;
      if (quantity) {
        requestData[`amount${index + 1}`] = quantity || 1;
        cartTotal += quantity;
      }
    });
    requestData.cartTotal = cartTotal;

    httpclient
      .post(`saveSalesOrder?env=TEST&erplyLogin=${erplyLogin}`, requestData)
      .then(({ data }) => {
        if (data.status === 200) {
          setOpenDialog(false);
          setOpen(true);
          setKeyLoading(false);
          setSnackStatus("success");
          setSnackMessage(data.message);
          setOpen1(true);
          // setTimeout(() => {
          //   setStep(0);
          // }, 1000);
          // setTimeout(() => {
          //   window.location.reload();
          // }, 3000);
          handleRefetch();
        }
        else {
          setOpenDialog(false);
          setOpen(true);
          setSnackStatus("error");
          setSnackMessage(data.message);
          setKeyLoading(false);
        }
      });
  }


  const handleUpdateSalesOrder = () => {
    setKeyLoading(true);
    const requestData = {
      type: "",
      warehouseID: pos,
      customerID: customerDetails.customerID,
      salesDocumentID: customerDetails.salesDocumentID,
      paymentType: paymentType,
      express: express,
      cartTotal: 0,
      attributeName1: "SchoolName",
      attributeType1: "text",
      attributeValue1: "",
    };

    const schoolIDs = customerDetails.cartItems.map((item) => item.schoolID); // Extract all schoolIDs from cartItems

    // Filter unique schoolIDs and join them as comma-separated values
    requestData.attributeValue1 = [...new Set(schoolIDs)].join(",");
    //console.log("schoolIDs", schoolIDs)
    let cartTotal = 0;
    customerDetails.cartItems.forEach((item, index) => {
      requestData[`productID${index + 1}`] = item.id;
      requestData[`price${index + 1}`] = item.RetailSalesPrice;
      requestData[`discount${index + 1}`] = "0";

      const quantity = customerDetails.quantity[item.id] || 1;
      if (quantity) {
        requestData[`amount${index + 1}`] = quantity || 1;
        cartTotal += quantity;
      }
    });
    requestData.cartTotal = cartTotal;
    httpclient
      .post(`saveSalesOrder?env=TEST&erplyLogin=${erplyLogin}`, requestData)
      .then(({ data }) => {
        if (data.status === 200) {
          setOpenDialog(false);
          setOpen(true);
          setKeyLoading(false);
          setSnackStatus("success");
          setSnackMessage(data.message);
          setOpen1(true);
          // setTimeout(() => {
          //   setStep(0);
          // }, 1000);

          // setTimeout(() => {
          //   window.location.reload();
          // }, 3000);
          handleRefetch();

        }
        else {
          setOpenDialog(false);
          setOpen(true);
          setSnackStatus("error");
          setSnackMessage(data.message);
          setKeyLoading(false);
        }
      });
  }

  // setTimeout(() => {
  //   window.location.reload();
  // }, 2000);


  const handleConfirmSalesOrder = () => {
    setKeyLoading1(true);
    const requestData = {
      type: "ORDER",
      warehouseID: pos,
      customerID: customerDetails.customerID,
      ...(payNow === true ? { payNow: true, isOfferToOrder: 1, ...(customerDetails.salesDocumentID !== null && { salesDocumentID: customerDetails.salesDocumentID }) } : { salesDocumentID: customerDetails.salesDocumentID, isOfferToOrder: 1 }),
      paymentType: paymentType,
      express: express,
      cartTotal: 0,
      isFinal: true,
      attributeName1: "SchoolName",
      attributeType1: "text",
      attributeValue1: "",
    };

    const schoolIDs = customerDetails.cartItems.map((item) => item.schoolID); // Extract all schoolIDs from cartItems

    // Filter unique schoolIDs and join them as comma-separated values
    requestData.attributeValue1 = [...new Set(schoolIDs)].join(",");
    //console.log("schoolIDs", schoolIDs)
    let cartTotal = 0;
    customerDetails.cartItems.forEach((item, index) => {
      requestData[`productID${index + 1}`] = item.id;
      requestData[`price${index + 1}`] = item.RetailSalesPrice;
      requestData[`discount${index + 1}`] = "0";

      const quantity = customerDetails.quantity[item.id] || 1;
      if (quantity) {
        requestData[`amount${index + 1}`] = quantity || 1;
        cartTotal += quantity;
      }
    });
    requestData.cartTotal = cartTotal;
    httpclient.post(`saveSalesOrder?env=TEST&erplyLogin=${erplyLogin}`, requestData).then(({ data }) => {
      if (data.status === 200) {
        setOpenDialog(false);
        setOpen(true);

        setKeyLoading1(false);
        setSnackStatus("success");
        setSnackMessage(data.message);
        setOpen1(true);
        handleRefetch();
        // setTimeout(() => {
        //   window.location.reload();
        // },3000)
        // setCustomerDetails({
        //   ...customerDetails,
        //   pickingSlipLink: data.records.records[0].pickingSlipLink,
        // });
        // showPrintPreview(data.records.records[0].pickingSlipLink);

      } else {
        setOpenDialog(false);
        setOpen(true);
        setSnackStatus("error");
        setSnackMessage(data.message);
        setKeyLoading1(false);
      }
    });
  };
  //console.log("Customer Details has been saved successfully! >>");


  // const showPrintPreview = (pickingSlipLink) => {
  //   if (pickingSlipLink) {
  //     setPrintDetails(pickingSlipLink);
  //     setShowPrintDialog(true);
  //   }
  // };

  // const callbackPrintPreview = (call) => {
  //   if (call.open === false) {
  //     setShowPrintDialog(false);
  //     setPrintDetails("");
  //     setTimeout(() => {
  //       window.location.reload();
  //     }, 1000);
  //   }
  // };

  const openPaymentTypeDialog = () => {
    setOpenDialog(true);
  };

  // Function to handle closing the dialog
  const closePaymentTypeDialog = () => {
    setOpenDialog(false);
  };
  const handlePaymentTypeChange = (event) => {
    setPaymentType(event.target.value);
  };
  // Function to handle selecting the payment type

  const handleFinish = () => {
    setCustomerDetails({
      firstName: "",
      lastName: "",
      mobile: "",
      email: "",
      notify: false,
      school: "",
      schoolID: "",
      grade: "",
      gender: "",
      quantity: [],
      cart: 0,
      cartTotal: "",
      cartItems: [],
      type: "",
    });
    setOpen(true);
    setSnackStatus("success");
    setSnackMessage("Customer Details Finish and Print successful!");
    handleRefetch();
  };

  const handleReset = () => {
    setResetConfirmationOpen(true);
  };

  const handleResetConfirmationCancel = () => {
    setResetConfirmationOpen(false);
  };

  const handleResetConfirmationConfirm = () => {
    setResetConfirmationOpen(false);
    setCustomerDetails({
      firstName: "",
      lastName: "",
      fullName: "",
      clientName: "",
      mobile: "",
      email: "",
      notify: false,
      school: "",
      schoolID: "",
      grade: "",
      gender: "",
      quantity: [],
      cart: 0,
      cartTotal: "",
      cartItems: [],
      type: "",
    });
    handleRefetch();
    setResetConfirmationOpen(false);
  };

  const handleCustomerConfirmationCancel = () => {

    setCustomerConfirmationOpen(false);
    setCustomerDetails({
      type: "new",
      firstName: "",
      lastName: "",
      fullName: "",
      clientName: "",
      mobile: "",
      email: "",
      notify: false,
      school: "",
      schoolID: "",
      grade: "",
      gender: "",
      quantity: [],
      cart: 0,
      cartTotal: "",
      cartItems: [],
      type: "new",
    });
  };


  const handleCustomerConfirmationConfirm = () => {
    setCustomerConfirmationOpen(false);
    setTimeout(() => {
      customerDetails.type = "existing"
      handleStep1();
    }, 500);
  };

  const handleChooseType = (value) => {
    if (value === "new") {
      setCustomerDetails({
        ...customerDetails,
        firstName: "",
        lastName: "",
        mobile: "",
        email: "",
        notify: false,
        school: "",
        schoolID: "",
        grade: "",
        gender: "",
        quantity: [],
        cart: 0,
        cartTotal: "",
        cartItems: [],
        type: value,
      });
      // setStep(step + 1);
    }
    if (value === "existing") {
      setCustomerDetails({
        ...customerDetails,
        fullName: "",
        mobile: "",
        email: "",
        notify: false,
        school: "",
        grade: "",
        gender: "",
        quantity: [],
        cart: 0,
        cartItems: [],
        type: value,
      });
      // setStep(step + 1);
    }
    if (value === "resume") {
      setCustomerDetails({
        ...customerDetails,
        type: value,
      });
      // setStep(step + 1);
    }
  };
  console.log("payNow", payNow);
  console.log("step", step);
  console.log("state", state);
  console.log("customer details", customerDetails);
  console.log("express", express);
  console.log("trigger", trigger);

  return (
    <div>
      <Container maxWidth="xl">
      <Box sx={{ width: "100%" }}>
        {step === 0 &&
          (customerDetails.type === "resume" ? (
            <>
              <ResumeCustomer
                step={step}
                setStep={setStep}
                customerDetails={customerDetails}
                rows={rows}
                rows1={rows1}
                //columns={columns1}
                columns2={columns2}
                handleResume={handleResume}
                keyLoading={keyLoading}
                setKeyLoading={setKeyLoading}
                deletingRow={deletingRow}
                setDeletingRow={setDeletingRow}
                handleDelete={handleDelete}
                //handleDelete={handleConfirmation}
                setCustomerDetails={setCustomerDetails}
              />
              {/* <Dialog
              open={openConfirmation}
              onClose={handleConfirmationClose}
              aria-labelledby="confirmation-dialog-title"
            >
              <DialogTitle id="confirmation-dialog-title">Confirm Delete</DialogTitle>
              <DialogContent>
                <p>Are you sure you want to delete?</p>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleConfirmationClose} color="primary">
                  Cancel
                </Button>
                <Button onClick={handleDelete} color="primary" autoFocus>
                  Delete
                </Button>
              </DialogActions>
            </Dialog> */}
            </>
          ) : customerDetails.type === "existing" ? (
            <ExistingCustomer
              step={step}
              setStep={setStep}
              customerDetails={customerDetails}
              setCustomerDetails={setCustomerDetails}
            />
          ) : (
            <FirstPage
              customerDetails={customerDetails}
              handleChooseType={handleChooseType}
              step={step}
              setStep={setStep}
              columns2={columns2}
              handleResume={handleResume}
              keyLoading={keyLoading}
              setKeyLoading={setKeyLoading}
              deletingRow={deletingRow}
              setDeletingRow={setDeletingRow}
              handleDelete={handleDelete}
            />
          ))}

        {step === 1 && (
          <>
            <BreadCrumb
              customerDetails={customerDetails}
              setCustomerDetails={setCustomerDetails}
              title1={
                customerDetails.type === "new"
                  ? `New Customer : ${customerDetails.firstName}`
                  : customerDetails.type === "resume"
                    ? `Resume Order : ${customerDetails.clientName}`
                    : `Existing Customer : ${customerDetails.firstName + " " + customerDetails.lastName}`
              }
              step={step}
              setStep={setStep}
            />
            <NewCustomerComponent
              step={step}
              setStep={setStep}
              customerDetails={customerDetails}
              handleChange={handleChange}
              handleCheck={handleCheck}
              handleSaveCustomerDetails={handleSaveCustomerDetails}
              openPaymentTypeDialog={openPaymentTypeDialog}
              //handleNextStep={handleNextStep}
              keyLoading={keyLoading}

            />
            <CustomerConfirmationDialog
              open={customerConfirmationOpen}
              customerDetails={customerDetails}
              onCancel={handleCustomerConfirmationCancel}
              onConfirm={handleCustomerConfirmationConfirm}

            />
          </>
        )}
        {step === 2 && (
          <>
            <BreadCrumb
              customerDetails={customerDetails}
              setCustomerDetails={setCustomerDetails}
              title1={
                customerDetails.type === "new"
                  ? `New Customer : ${customerDetails.firstName}`
                  : customerDetails.type === "resume"
                    ? `Resume Order : ${customerDetails.clientName}`
                    : `Existing Customer : ${customerDetails.firstName + " " + customerDetails.lastName}`
              }
              title2={customerDetails.school}
              step={step}
              setStep={setStep}
            />
            <SelectSchool
              schoolList={schoolList}
              customerDetails={customerDetails}
              handleChange={handleChange}
              handleClickSchool={handleClickSchool}
              handleClickSchool1={handleClickSchool1}
              handleChangeSchool={handleChangeSchool}
              step={step}
              setStep={setStep}
              handleQuantity={handleQuantity}
              handleAdd={handleAdd}
              handleSubstract={handleSubstract}
              handleRemoveFromCart={handleRemoveFromCart}
              state={state}
              setState={setState}
            />
          </>
        )}
        {/* {step === 3 && (
          <>
            <BreadCrumb
              customerDetails={customerDetails}
              setCustomerDetails={setCustomerDetails}
              title1={
                customerDetails.type === "new"
                  ? "New Customer"
                  : "Existing Customer"
              }
              title2={customerDetails.school}
              title3={customerDetails.grade}
              step={step}
              setStep={setStep}
            />
            <SelectGrade
              customerDetails={customerDetails}
              handleChange={handleChange}
              handleChangeGrade={handleChangeGrade}
              step={step}
              setStep={setStep}
            />
          </>
        )} */}
        {/* {step === 3 && (
          <>
            <BreadCrumb
              customerDetails={customerDetails}
              setCustomerDetails={setCustomerDetails}
              title1={
                customerDetails.type === "new"
                  ? "New Customer"
                  : customerDetails.type === "resume"
                    ? "Resume Order"
                    : "Existing Customer"
              }
              title2={customerDetails.school}
              title3={customerDetails.grade}
              title4={customerDetails.gender}
              step={step}
              setStep={setStep}
            />
            <SelectGender
              step={step}
              setStep={setStep}
              customerDetails={customerDetails}
              handleChooseGender={handleChooseGender}
            />
          </>
        )} */}

        {step === 3 && (
          <>
            <BreadCrumb
              customerDetails={customerDetails}
              setCustomerDetails={setCustomerDetails}
              title1={
                customerDetails.type === "new"
                  ? `New Customer : ${customerDetails.firstName}`
                  : customerDetails.type === "resume"
                    ? `Resume Order : ${customerDetails.clientName}`
                    : `Existing Customer : ${customerDetails.firstName + " " + customerDetails.lastName}`
              }
              title2={customerDetails.school}
              title3={customerDetails.grade}
              title4={customerDetails.gender}
              title5={"Product"}
              step={step}
              setStep={setStep}
            />
            <ProductPage
              step={step}
              setStep={setStep}
              //productslist={productslist}
              customerDetails={customerDetails}
              express={express}
              setExpress={setExpress}
              keyLoading={keyLoading}
              setKeyLoading={setKeyLoading}
              keyLoading1={keyLoading1}
              setKeyLoading1={setKeyLoading1}
              handleQuantity={handleQuantity}
              handleAdd={handleAdd}
              handleSubstract={handleSubstract}
              //handleOpenOptions={handleOpenOptions}
              handleAddToCart={handleAddToCart}
              handleRemoveFromCart={handleRemoveFromCart}
              handleReset={handleReset}
              handleSaveCustomerDetails={handleSaveCustomerDetails}
              handleSaveSalesOrder={handleSaveSalesOrder}
              handleUpdateSalesOrder={handleUpdateSalesOrder}
              handleConfirmSalesOrder={handleConfirmSalesOrder}
              handleFinish={handleFinish}
              openPaymentTypeDialog={openPaymentTypeDialog}
              state={state}
              setState={setState}
              payNow={payNow}
              setPayNow={setPayNow}
              trigger={trigger}
              setTrigger={setTrigger}

            />
            <ResetConfirmationDialog
              open={resetConfirmationOpen}
              onCancel={handleResetConfirmationCancel}
              onConfirm={handleResetConfirmationConfirm}

            />
            <AddPaymentType
              openDialog={openDialog}
              closePaymentTypeDialog={closePaymentTypeDialog}
              handleSaveSalesOrder={handleSaveSalesOrder}
              paymentType={paymentType}
              handlePaymentTypeChange={handlePaymentTypeChange}
            />
          </>
        )}
        </Box>
      </Container>

      {/* {openViewOptions && (
        <OptionDialog
          //viewOptionDetails={viewOptionDetails}
          //sendOption={sendOption}
          handleAdd={handleAdd}
          handleSubstract={handleSubstract}
          handleQuantity={handleQuantity}
          handleAddToCart={handleAddToCart}
          customerDetails={customerDetails}
        />
      )} */}

      {/* {showPrintDialog && (
        <PrintDialog
          printDetails={printDetails}
          callbackPrintPreview={callbackPrintPreview}
        />
      )} */}

      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open1}

      >
        <CircularProgress color="inherit" />
        <Typography variant="h6" component="div">
          &nbsp;&nbsp; Fetching...
        </Typography>
      </Backdrop>

      <Snackbar
        open={open}
        autoHideDuration={1000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleClose}
          severity={snackStatus}
          sx={{ width: "100%", position: "relative", top: "40px" }}
        >
          {snackMessage}
        </Alert>
      </Snackbar>

      <Snackbar
        open={open2}
        // autoHideDuration={1000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleClose}
          severity={snackStatus}
          sx={{
            width: "100%",
            position: "relative",
            //top: "40px",
            marginBottom: "35%", // Add this line to set the bottom margin
          }}
        >
          {snackMessage}
        </Alert>
      </Snackbar>


    </div>
  );
};

export default Home;
